export const DEFAULT_PAGINATION_LIMIT = 50;
export const DEFAULT_PAGINATION_PAGE = 1;
